import React, { useEffect, useState } from "react";
import { useAuth, isExpired } from "../../contexts/AuthContext";
import { Alert, Box, Button, Link, Snackbar, Typography } from "@mui/material";
import { InvokeAPI } from "../../apis/API";
import { useNavigate } from "react-router-dom";

function Expiredbanner() {
    const { user, logout } = useAuth();
    const navigate = useNavigate();
    
    return (
        <>
            {isExpired() ?
                <Box 
                    display="flex" 
                    justifyContent="center" 
                    alignItems="center" 
                    textAlign="center" 
                    sx={{ 
                        padding: '6px 16px', 
                        width: '100%', 
                        zIndex: 1000, 
                        position: 'fixed', 
                        bottom: '0', 
                        background: 'linear-gradient(135deg, #d32f2f 0%, #c62828 100%)',
                        color: 'white',
                        boxShadow: '0 -4px 20px rgba(0,0,0,0.2)',
                        animation: 'slideUp 0.4s ease-out',
                        '@keyframes slideUp': {
                            from: {
                                opacity: 0,
                                transform: 'translateY(100%)',
                            },
                            to: {
                                opacity: 1,
                                transform: 'translateY(0)',
                            },
                        },
                    }}
                >
                    <Typography sx={{ flexGrow: 1, mr: 2, fontWeight: 500, fontSize: '0.875rem', lineHeight: 1.2 }}>
                        Your Trial period is over. &nbsp; &nbsp;
                        <Button  
                        onClick={(e)=>{e.preventDefault();navigate("/app/activate")}} 
                        type="submit" 
                        variant="contained" 
                        color="success" 
                        size="small"
                        sx={{ 
                            minWidth: '140px',
                            fontSize: '0.875rem',
                            py: 0.5,
                            px: 2,
                            height: '32px',
                            backgroundColor: '#2e7d32',
                            '&:hover': {
                                backgroundColor: '#1b5e20',
                                transform: 'translateY(-2px)',
                                boxShadow: (theme) => theme.shadows[8],
                            },
                            transition: 'all 0.2s ease-in-out',
                        }}
                    >
                        Click To Activate
                    </Button>
                    </Typography>

                </Box>
                : <></>
            }
        </>
    );
}

export default Expiredbanner;